// 4.0产品详情页内容组件
import './index.less'
import { PdpLeftTextRightImg } from './snippets/pdp-left-text-right-img';
import WhatIsInTheBox from './snippets/what-is-in-the-box';
import { replaceLineBreak } from '@utils/index.js';

import PhotovolaticCommentList from "../photovolatic-collection/sections/photovolatic-comment-list";
import "../photovolatic-collection/sections/photovolatic-comment-list/index.less";

import { gaProductDetailDataLayer } from '@utils/index.js'


document.addEventListener('DOMContentLoaded', () => {
	PdpLeftTextRightImg()
	WhatIsInTheBox()

	// Comment 案例推荐
	try {
		document.querySelector(".commentlist-pc-swiper") && new PhotovolaticCommentList({
			pcEl: ".commentlist-pc-swiper",
			mbEl: ".commentlist-mb-swiper",
		})
	} catch (error) {
		console.log(error)
	}


	// 灵活矩阵
	if (document.querySelector(".pdp-matrix")) {
		let domWidth = document.body.scrollWidth;
		$('.pdp-matrix').each(function () {
			const matrixGraphList = $(this).find('.product-detail-matrix-graph .matrix-graph-list');
			if (matrixGraphList.children().length === 0) {
				$(this).remove();
			}
			let pclist =$(this).find('.matrix-graph-content.pc-block .matrix-graph-list')
			let mblist =$(this).find('.matrix-graph-content.mb-block .matrix-graph-list')
			if (domWidth > 1024) {
				if (pclist.children().length === 0){
					$(this).find('.product-detail-matrix-graph').css('margin-bottom', '0');
				}
			} else {
				if (mblist.children().length === 0){
					$(this).find('.product-detail-matrix-graph').css('margin-bottom', '0');
				}
			}
		});

		const lastMediaHighlight = $('.pdp-matrix').last();
		const firstMediaHighlight = $('.pdp-matrix').first();
		const pcTop =$('.pdp-matrix .product-detail-matrix').data('top-pc')
		const pcBottom =$('.pdp-matrix .product-detail-matrix').data('bottom-pc')
		const mbTop =$('.pdp-matrix .product-detail-matrix').data('top-mb')
		const mbBottom =$('.pdp-matrix .product-detail-matrix').data('bottom-mb')
		if (domWidth > 1024) {
			if (pcBottom > 0) {
				lastMediaHighlight.css('margin-bottom', pcBottom + 'px');
			}
			if (pcTop > 0) {
				firstMediaHighlight.css('padding-top', pcTop + 'px');
			}
		} else {
			if (mbBottom > 0) {
				lastMediaHighlight.css('padding-bottom', mbBottom + 'vw');
			}
			if (mbTop > 0) {
				firstMediaHighlight.css('padding-top', mbTop + 'vw');
			}
		}
		$('.section-matrix-graph .product-detail-matrix-graph').each(function () {
			let columnTemplate, items, gridList;
			if (domWidth > 1024) {
				gridList = $(this).find('.pc-block .matrix-graph-list');
				columnTemplate = gridList.attr('data-grid-columns');
				items = $(this).find('.pc-block .matrix-graph-item');
				gridList.css('grid-template-columns', columnTemplate);
				const columnCount = columnTemplate.split(' ').length;
				items.each(function (index) {
					$(this).css('display', index < columnCount ? 'block' : 'none');
				});
			} else {
				gridList = $(this).find('.mb-block .matrix-graph-list');
				columnTemplate = gridList.attr('data-grid-columns');
				items = $(this).find('.mb-block .matrix-graph-item');
				gridList.css('grid-template-columns', 'repeat(2, 1fr)');
				const columnTemplateNum = Number(columnTemplate);
				if (columnTemplateNum > 1 && columnTemplateNum < 4) {
					switch (columnTemplateNum) {
						case 2:
							items.eq(0).css('grid-column', '1 / 3');
							break;
						case 3:
							items.eq(2).css('grid-column', '1 / 3');
							break;
					}
					items.eq(3).css('display', 'none');
				}
				if(columnTemplateNum == 4){
                    items.css('grid-column', 'span 2')
                    items.eq(2).css('display', 'none');
                }
			}
		});
		$('.pdp-matrix').css('visibility', 'visible');
	}

	// 规格
	if (!customElements.get('product-specs')) {
		customElements.define('product-specs', class ProductSpecs extends HTMLElement {
			constructor() {
				super()
				this.selectors = {
					accordion_header: $(this).find(".accordion-ul .accordion-header"),
					specs_dom: $(this).find(".accordion-content--with-child.specs"),
					manual: $(this).find(".manual-list")
				}

				// 规格 section title
				this.productSpecsTitle = this.querySelector('.tech--title').innerText

				this.init()
				this?.getSpecsInfo()
				this?.getUserManual()
			}

			init() {
				this.specVariant()
				this.selectors.accordion_header.click(function () {
					$(this).next('.accordion-content').slideToggle()
					$(this).find(".accordion-close").toggleClass("active")
				})
			}

			specVariant(init = true) { // 加电包
				$(".accordion-header--variant:not(.active)").next('.accordion-content').slideUp(0)
				$(".accordion-header--variant:not(.active)").find(".accordion-close").removeClass("active")

				if (!init) {
					$(".accordion-header--variant.active").next('.accordion-content').slideDown(0)
					$(".accordion-header--variant.active").find(".accordion-close").addClass("active")
				}
			}

			createSpecsItemDom(obj) {
				let html = ''
				for (let n in obj) {
					if (typeof (obj[n]) === 'string') {
						html += `
						<div class="specs-item">
								<span class="key">${n}</span>
								<span class="value">${replaceLineBreak(obj[n])}</span>

						</div>
						`
					} else {
						html += this.createSpecsItemDom(obj[n])
					}
				}
				return html
			}

			createSpecsDom(data = []) {
				let box = '';
				data.map(item => {
					if (item.baseInfos) {
						// 过滤特殊逻辑
						Object.keys(item.baseInfos).forEach(key => {
							if (['Price', 'In The Box', 'Solar Charging Time'].includes(key)) {
								delete item.baseInfos[key]
							}
						})

						let row = '';
						for (let i in item.baseInfos) {
							let col = '';
							if (item.baseInfos[i]) {
								let obj = item.baseInfos[i]
								if (typeof (obj) === 'string') {
									col += `
										<div class="specs-item">
											<span class="key">${obj}</span>
										</div>
									`
								} else {
									col += this.createSpecsItemDom(obj)
								}
							}
							row += `
								<div class="specs-row w-full">
									<div class="title">${i}</div>
									<div class="specs-wrap">
										${col}
									</div>
								</div>
							`
						}
						box += `
							<div class="accordion-ul">
								<div class="accordion-header">
									<h3 class="jky-text-lg font-bold">${item.title}</h3>
									<svg class="accordion-close active" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2530" width="36" height="36"><path d="M512 671.288889L785.066667 398.222222l-56.888889-62.577778L512 551.822222 295.822222 335.644444 233.244444 398.222222z" fill="currentColor" opacity=".6" p-id="2531"></path></svg>
								</div>

								<div class="accordion-content">
									<div class="item-box-content w-full">${row}</div>
								</div>
							</div>
						`
					}
				})
				return box
			}

			// 产品参数获取
			getSpecsInfo(skuId) {
				const _this = this
				var sku_id = skuId
				if (!skuId) {
					const productForm = document.querySelector("product-form")
					const variantFields = document.querySelector('variant-fields')
					sku_id = productForm?.querySelector('[name=id]')?.value
						|| variantFields?.currentVariant?.id
						|| this.getAttribute("data-id")
				}

				fetch(`${pageInfo.api}/osconsumerapi/app-product-comparison/consumer/detail?shopifyShopId=${pageInfo.shopId}&skuId=${sku_id}`)
					.then((response) => response.json())
					.then(res => {
						let data = res.data;
						let dom = this.createSpecsDom(data)
						if (data && Array.isArray(data) && data.length) {
							document.querySelector(".accordion--product-specs") && document.querySelector(".accordion--product-specs").classList.remove("hidden")
							this.selectors.specs_dom.html(dom)
							this.selectors.specs_dom.find(".accordion-header").click(function () {
								$(this).next('.accordion-content').slideToggle()
								$(this).find(".accordion-close").toggleClass("active")

								// 只记录二级产品参数的埋码
								gaProductDetailDataLayer({
									"product_spu_name": _this.dataset.productTitle, // 识别页面产品spu标题名称text
									"module": "Parameter", // 固定名称Parameter
									"content": _this.productSpecsTitle, // 识别参数配置标题文本text
									"position": _this.selectors.specs_dom?.prev()?.text()?.trim(), // 一级展开分类文本text
									"button_name": $(this)?.text()?.trim(), // 二级展开分类文本text,或者产品说明书名称
									"type": $(this).find(".accordion-close").hasClass("active") ? "open" : "fold", // 折叠fold，展开open / 下载-PDF Download
								})
							})
						} else {
							this.selectors.specs_dom.find('.accordion-ul').empty()
							document.querySelector(".accordion--product-specs") && document.querySelector(".accordion--product-specs").classList.add("hidden")
						}
					})
					.catch(e => console.error("Fetch error: getSpecsInfo", e))
			}

			// 说明书
			getUserManual(sku) {
				const productForm = document.querySelector("product-form")
				const variantFields = document.querySelector('variant-fields')

				var sku_id = sku
				if (!sku) {
					sku_id = productForm?.querySelector('[name=id]')?.getAttribute("data-sku")
						|| variantFields?.currentVariant?.sku
						|| this.getAttribute("data-sku")
				}
				this.selectors.manual.find("dd").remove();

				// 如果shopify元字段有配置，则取shopify的，没有则取接口
				const current_id = productForm?.querySelector('[name=id]')?.value
				  || variantFields?.currentVariant?.id
					|| this.getAttribute("data-id")
				const _currentVariant = window.product.productVariants[current_id]
				const batteryInfos = _currentVariant.batteryInfos || []
				if (batteryInfos.length > 0) {
					document.querySelector(".accordion--manual") && document.querySelector(".accordion--manual").classList.remove("hidden")
					let dd = '';
					batteryInfos.forEach(item => {
						dd += `
							<dd>
								<p class="jky-text-sm font-500">
									<svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
										<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
											<g transform="translate(-155.000000, -4087.000000)" stroke="#333333" stroke-width="2">
												<g transform="translate(120.000000, 3988.000000)">
													<g transform="translate(24.000000, 88.000000)">
														<g transform="translate(12.000000, 12.000000)">
															<path d="M35.1219512,33.1707317 L35.1219512,37.671137 C35.1219512,38.9572127 34.1185581,40 32.8810674,40 L6.63112772,40 C5.39363706,40 4.3902439,38.9572127 4.3902439,37.671137 L4.3902439,33.2640066" id="Stroke-1"></path>
															<path d="M4.3902439,16.51676 L4.3902439,2.28040889 C4.3902439,1.02109117 5.39363706,0 6.63112772,0 L32.8810674,0 C34.1185581,0 35.1219512,1.02109117 35.1219512,2.28040889 L35.1219512,16.5853659" id="Stroke-3"></path>
															<path d="M38.3476085,33.1707317 L1.65239148,33.1707317 C0.739610262,33.1707317 0,32.4236961 0,31.5017509 L0,18.2543467 C0,17.3324015 0.739610262,16.5853659 1.65239148,16.5853659 L38.3476085,16.5853659 C39.2603897,16.5853659 40,17.3324015 40,18.2543467 L40,31.5017509 C40,32.4236961 39.2603897,33.1707317 38.3476085,33.1707317 Z" id="Stroke-5"></path>
															<line x1="10.2439024" y1="5.6097561" x2="29.2682927" y2="5.6097561" id="Stroke-7"></line>
															<line x1="10.2439024" y1="10.9756098" x2="29.2682927" y2="10.9756098" id="Stroke-9"></line>
															<line x1="10.4878049" y1="29.2682927" x2="10.4878049" y2="21.4634146" id="Stroke-11"></line>
															<polyline id="Stroke-13" points="24.8780488 29.2682927 24.8780488 21.4634146 28.7804878 21.4634146"></polyline>
															<path d="M10.7317073,21.4634146 L13.385397,21.4634146 C14.3441607,21.4634146 15.1219512,22.2282453 15.1219512,23.1709435 C15.1219512,24.1140652 14.3441607,24.8780488 13.385397,24.8780488 L10.7317073,24.8780488" id="Stroke-15"></path>
															<path d="M18.612952,29.2682927 L17.0731707,29.2682927 L17.0731707,21.4634146 L18.612952,21.4634146 C20.7263935,21.4634146 22.4390244,23.2106546 22.4390244,25.3658537 C22.4390244,27.5210527 20.7263935,29.2682927 18.612952,29.2682927 Z" id="Stroke-17"></path>
															<line x1="28.7804878" y1="25.1219512" x2="24.8780488" y2="25.1219512" id="Stroke-19"></line>
														</g>
													</g>
												</g>
											</g>
										</g>
									</svg>
									<span>${item.title}</span>
								</p>
								<span data-href="${item.url}" data-title="${item.title}" class="z-button-fill-middle font-500"><i class="iconfont jackery-icon-download"></i>&nbsp;<span>${window.pageInfo.strings.product.download}</span></span>
							</dd>
						`;
					})
					this.selectors.manual.prepend(dd)

					// 给 download 按钮，注册埋码事件
					const _this = this
					this.selectors.manual.find('.z-button-fill-middle').click(function() {
						// 数据埋码
						gaProductDetailDataLayer({
							"product_spu_name": _this.dataset.productTitle, // 识别页面产品spu标题名称text
							"module": "Parameter", // 固定名称Parameter
							"content": _this.productSpecsTitle, // 识别参数配置标题文本text
							"position": _this.selectors.manual.data("section-title"), // 一级展开分类文本text
							"button_name": $(this)?.data("title"), // 产品说明书名称
							"type": "PDF Download", // 折叠fold，展开open / 下载-PDF Download
						})

						window.open($(this).data('href'), '_blank')
					})
					return false
				} else {
					document.querySelector(".accordion--manual") && document.querySelector(".accordion--manual").classList.add("hidden")
				}

				// 判断是套装还是单品, 套装查询getPackagedInfo, 单品查询getGoodsInfo
				if (this.selectors.manual.attr("type") === 'sg_gather') {
					fetch(`${pageInfo.api}/osconsumerapi/v1/goods/packaged-info?shopify_shop_id=${pageInfo.shopId}&sku=${sku_id}`)
						.then((response) => response.json())
						.then(res => {
							let dd = '';
							res.data.filter((item) => !!item.introduceBookUrlDesc).forEach((item) => {
								dd += `
									<dd>
										<p class="jky-text-sm font-500">
											<svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
												<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
													<g transform="translate(-155.000000, -4087.000000)" stroke="#333333" stroke-width="2">
														<g transform="translate(120.000000, 3988.000000)">
															<g transform="translate(24.000000, 88.000000)">
																<g transform="translate(12.000000, 12.000000)">
																	<path d="M35.1219512,33.1707317 L35.1219512,37.671137 C35.1219512,38.9572127 34.1185581,40 32.8810674,40 L6.63112772,40 C5.39363706,40 4.3902439,38.9572127 4.3902439,37.671137 L4.3902439,33.2640066" id="Stroke-1"></path>
																	<path d="M4.3902439,16.51676 L4.3902439,2.28040889 C4.3902439,1.02109117 5.39363706,0 6.63112772,0 L32.8810674,0 C34.1185581,0 35.1219512,1.02109117 35.1219512,2.28040889 L35.1219512,16.5853659" id="Stroke-3"></path>
																	<path d="M38.3476085,33.1707317 L1.65239148,33.1707317 C0.739610262,33.1707317 0,32.4236961 0,31.5017509 L0,18.2543467 C0,17.3324015 0.739610262,16.5853659 1.65239148,16.5853659 L38.3476085,16.5853659 C39.2603897,16.5853659 40,17.3324015 40,18.2543467 L40,31.5017509 C40,32.4236961 39.2603897,33.1707317 38.3476085,33.1707317 Z" id="Stroke-5"></path>
																	<line x1="10.2439024" y1="5.6097561" x2="29.2682927" y2="5.6097561" id="Stroke-7"></line>
																	<line x1="10.2439024" y1="10.9756098" x2="29.2682927" y2="10.9756098" id="Stroke-9"></line>
																	<line x1="10.4878049" y1="29.2682927" x2="10.4878049" y2="21.4634146" id="Stroke-11"></line>
																	<polyline id="Stroke-13" points="24.8780488 29.2682927 24.8780488 21.4634146 28.7804878 21.4634146"></polyline>
																	<path d="M10.7317073,21.4634146 L13.385397,21.4634146 C14.3441607,21.4634146 15.1219512,22.2282453 15.1219512,23.1709435 C15.1219512,24.1140652 14.3441607,24.8780488 13.385397,24.8780488 L10.7317073,24.8780488" id="Stroke-15"></path>
																	<path d="M18.612952,29.2682927 L17.0731707,29.2682927 L17.0731707,21.4634146 L18.612952,21.4634146 C20.7263935,21.4634146 22.4390244,23.2106546 22.4390244,25.3658537 C22.4390244,27.5210527 20.7263935,29.2682927 18.612952,29.2682927 Z" id="Stroke-17"></path>
																	<line x1="28.7804878" y1="25.1219512" x2="24.8780488" y2="25.1219512" id="Stroke-19"></line>
																</g>
															</g>
														</g>
													</g>
												</g>
											</svg>
											<span>${item.title}</span>
										</p>
										<span data-href="${item.introduceBookUrlDesc}" data-title="${item.title}" class="z-button-fill-middle font-500"><i class="iconfont jackery-icon-download"></i>&nbsp;<span>${window.pageInfo.strings.product.download}</span></span>
									</dd>
								`;
							});

							this.selectors.manual.prepend(dd)

							if(document.querySelector(".accordion--manual")) {
								document.querySelectorAll(".accordion--manual dl dd").length > 0 && document.querySelector(".accordion--manual").classList.remove("hidden")
							}

							// 给 download 按钮，注册埋码事件
							const _this = this
							this.selectors.manual.find('.z-button-fill-middle').click(function() {
								gaProductDetailDataLayer({
									"product_spu_name": _this.dataset.productTitle, // 识别页面产品spu标题名称text
									"module": "Parameter", // 固定名称Parameter
									"content": _this.productSpecsTitle, // 识别参数配置标题文本text
									"position": _this.selectors.manual.data("section-title"), // 一级展开分类文本text
									"button_name": $(this)?.data("title"), // 产品说明书名称
									"type": "PDF Download", // 折叠fold，展开open / 下载-PDF Download
								})

								window.open($(this).data('href'), '_blank')
							})
						})
				} else {
					fetch(`${pageInfo.api}/osconsumerapi/v1/goods/info?shopify_shop_id=${pageInfo.shopId}&sku=${sku_id}`)
						.then((response) => response.json())
						.then(r => {
							if (r.data && r.data.introduceBookUrlDesc) {
								const d_html = `
									<dd>
										<p class="jky-text-sm font-500">
											<svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
												<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
													<g transform="translate(-155.000000, -4087.000000)" stroke="#333333" stroke-width="2">
														<g transform="translate(120.000000, 3988.000000)">
															<g transform="translate(24.000000, 88.000000)">
																<g transform="translate(12.000000, 12.000000)">
																	<path d="M35.1219512,33.1707317 L35.1219512,37.671137 C35.1219512,38.9572127 34.1185581,40 32.8810674,40 L6.63112772,40 C5.39363706,40 4.3902439,38.9572127 4.3902439,37.671137 L4.3902439,33.2640066" id="Stroke-1"></path>
																	<path d="M4.3902439,16.51676 L4.3902439,2.28040889 C4.3902439,1.02109117 5.39363706,0 6.63112772,0 L32.8810674,0 C34.1185581,0 35.1219512,1.02109117 35.1219512,2.28040889 L35.1219512,16.5853659" id="Stroke-3"></path>
																	<path d="M38.3476085,33.1707317 L1.65239148,33.1707317 C0.739610262,33.1707317 0,32.4236961 0,31.5017509 L0,18.2543467 C0,17.3324015 0.739610262,16.5853659 1.65239148,16.5853659 L38.3476085,16.5853659 C39.2603897,16.5853659 40,17.3324015 40,18.2543467 L40,31.5017509 C40,32.4236961 39.2603897,33.1707317 38.3476085,33.1707317 Z" id="Stroke-5"></path>
																	<line x1="10.2439024" y1="5.6097561" x2="29.2682927" y2="5.6097561" id="Stroke-7"></line>
																	<line x1="10.2439024" y1="10.9756098" x2="29.2682927" y2="10.9756098" id="Stroke-9"></line>
																	<line x1="10.4878049" y1="29.2682927" x2="10.4878049" y2="21.4634146" id="Stroke-11"></line>
																	<polyline id="Stroke-13" points="24.8780488 29.2682927 24.8780488 21.4634146 28.7804878 21.4634146"></polyline>
																	<path d="M10.7317073,21.4634146 L13.385397,21.4634146 C14.3441607,21.4634146 15.1219512,22.2282453 15.1219512,23.1709435 C15.1219512,24.1140652 14.3441607,24.8780488 13.385397,24.8780488 L10.7317073,24.8780488" id="Stroke-15"></path>
																	<path d="M18.612952,29.2682927 L17.0731707,29.2682927 L17.0731707,21.4634146 L18.612952,21.4634146 C20.7263935,21.4634146 22.4390244,23.2106546 22.4390244,25.3658537 C22.4390244,27.5210527 20.7263935,29.2682927 18.612952,29.2682927 Z" id="Stroke-17"></path>
																	<line x1="28.7804878" y1="25.1219512" x2="24.8780488" y2="25.1219512" id="Stroke-19"></line>
																</g>
															</g>
														</g>
													</g>
												</g>
											</svg>
											<span>${r.data.title}</span>
										</p>
										<span data-href="${r.data.introduceBookUrlDesc}" data-title="${r.data.title}" class="z-button-fill-middle font-500"><i class="iconfont jackery-icon-download"></i>&nbsp;<span>${window.pageInfo.strings.product.download}</span></span>
									</dd>
								`;
								this.selectors.manual.prepend(d_html);
								if(document.querySelector(".accordion--manual")) {
									document.querySelectorAll(".accordion--manual dl dd").length > 0 && document.querySelector(".accordion--manual").classList.remove("hidden")
								}

								// 给 download 按钮，注册埋码事件
								const _this = this
								this.selectors.manual.find('.z-button-fill-middle').click(function() {
									gaProductDetailDataLayer({
										"product_spu_name": _this.dataset.productTitle, // 识别页面产品spu标题名称text
										"module": "Parameter", // 固定名称Parameter
										"content": _this.productSpecsTitle, // 识别参数配置标题文本text
										"position": _this.selectors.manual.data("section-title"), // 一级展开分类文本text
										"button_name": $(this)?.data("title"), // 产品说明书名称
										"type": "PDF Download", // 折叠fold，展开open / 下载-PDF Download
									})
									window.open($(this).data("href"), '_blank')
								})
							}
						})
				}
			}
		})
	}

	// faq
	if (!customElements.get('product-faq-columns')) {
		customElements.define('product-faq-columns', class ProductFaq extends HTMLElement {
			constructor() {
				super()

				this.selectors = {
					faq_columns: $(this).find(".produc-detail--faq-left"),
					faq_columns_name: $(this).find(".produc-detail--faq-left .faq-category-name"),
					faq_content: $(this).find(".produc-detail--faq-right ul[data-index]"),
					faq_content_header: $(this).find(".produc-detail--faq-right ul[data-index] li .faq-header"),
					more_btn: $(this).find(".faq--more")
				}
				this.init()
			}

			init() {
				const _this = this

				// FAQ 按分类展示
				if (this.selectors.faq_columns?.length > 0) {
					this.selectors.faq_content.eq(0).find('.faq-header').eq(0).addClass("active")
					this.selectors.faq_content.eq(0).find('.faq-content').eq(0).slideDown()

					// faq分类 点击
					this.columnClick()
				}
				// FAQ 不按分类展示
				else {
					// 先收起全部
					this.selectors.faq_content_header.each(function () {
						$(this).next('.faq-content').slideUp()
						$(this).removeClass("active")
					})

					// 默认展开第一个
					this.selectors.faq_content.eq(0).find('.faq-header').eq(0).addClass("active")
					this.selectors.faq_content.eq(0).find('.faq-content').eq(0).slideDown()
				}


				// faq header 点击
				this.selectors.faq_content_header.click(function () {
					$(this).next('.faq-content').slideToggle()
					$(this).toggleClass("active")

					const activeElement = _this.selectors.faq_columns_name.filter(function() {
						return $(this).hasClass("active");
					});
					// 数据埋码
					gaProductDetailDataLayer({
						"module": "FAQ", // 固定名称FAQ
						"position": _this.selectors.faq_columns?.length > 0 ? activeElement.text().trim() : null, // 左侧分类名称文本text。若无配置则无需识别。
						"button_name": $(this).text().trim(), // 问题文本内容text
						"type": $(this).hasClass("active") ? "open" : "fold", // 折叠fold，展开open。
					})
				})

				// 跳转链接按钮 点击
				if (this.selectors.more_btn) {
					if ((this.selectors.more_btn).attr('href') !== '') {
						this.selectors.more_btn.css('display', 'block');
					}
					this.selectors.more_btn.click(function() {
						const activeElement = _this.selectors.faq_columns_name?.filter(function() {
							return $(this).hasClass("active");
						});
						// 数据埋码
						gaProductDetailDataLayer({
							"module": "Parameter", // 固定名称Parameter
							"position": activeElement?.text()?.trim() || null, // 左侧分类名称文本text。若无配置则无需识别。
							"button_name": $(this)?.text()?.trim(), // 按钮名称文本text
							"link": $(this).attr('href'), // 跳转链接
						})
					})
				}
			}
			columnClick() {
				const _this = this
				const columnsContainer = this.selectors.faq_columns.get(0)
				const len = this.selectors.faq_columns_name.length

				this.selectors.faq_columns_name.click(function() {
					if ($(this).hasClass('active')) {
						// 滚动到容器顶部
						window.scrollTo({
							top: _this.getElementTopPosition(),
							behavior: "smooth"
						})
						return
					}

					$(this).addClass('active')
					$(this).siblings().removeClass('active')

					const index = $(this).data('index')
					const viewMoreLink = $(this).data('view-more-link')

					_this.selectors.faq_content.hide()
					_this.selectors.faq_content.eq(index).show()

					if (viewMoreLink) {
						_this.selectors.more_btn.css("display", "block");
						_this.selectors.more_btn.attr('href', viewMoreLink)
					} else {
						_this.selectors.more_btn.css("display", "none");
					}


					// 计算目标元素相对于容器的偏移量，使其水平居中
					const element = $(this).get(0)
					const offsetLeft = element.offsetLeft - columnsContainer.offsetWidth / 2 + element.offsetWidth / 2;

					// 使用 scrollLeft 平滑滚动
					columnsContainer.scrollTo({
						left: offsetLeft,
						behavior: "smooth"
					});

					// 滚动到最后一个了，去掉 after 伪类
					if (index === len - 1) {
						columnsContainer.parentElement.classList.add('no-after')
					} else {
						columnsContainer.parentElement.classList.remove('no-after')
					}

					// 先收起全部
					_this.selectors.faq_content_header.each(function () {
						$(this).next('.faq-content').slideUp()
						$(this).removeClass("active")
					})

					// 展开当前
					_this.selectors.faq_content.eq(index).find('.faq-header').eq(0).addClass("active")
					_this.selectors.faq_content.eq(index).find('.faq-content').eq(0).slideDown()

					// 滚动到容器顶部
					window.scrollTo({
						top: _this.getElementTopPosition(),
						behavior: "smooth"
					})

					// 数据埋码
					gaProductDetailDataLayer({
						"product_spu_name": $(this).data('product-title'), //识别页面产品spu标题名称text
						"module": "FAQ", // 固定名称FAQ
						"position": $(this)?.text(), // 左侧分类名称文本text。若无配置则无需识别。
					})
				})
			}
			getElementTopPosition() {
				const rect = this.getBoundingClientRect()  // 获取元素相对于视口的位置
				const tabsH = document.querySelector('.product-tabs-container')?.getBoundingClientRect()?.height || 0
				return rect.top + window.scrollY - tabsH  // 元素距离页面顶部的高度
			}
		})
	}
})
